import React, { useEffect } from 'react';
import { useDispatch  } from "react-redux";
import { useQuery } from 'react-query';
import CircularProgress from "@mui/material/CircularProgress";
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Box from '@mui/material/Box'
import { Tag } from '../../../../models';

import api, { PagenatedRequest } from '../../../../api/medAppApi'
import pluralize from 'pluralize';
import { putMessage } from '../../../app/store/actions';

interface ISpecialization {
    handleChange: (event: SelectChangeEvent) => void;
    selected: Tag;
    setTags: (tags: Tag[]) => void;
    tags: Tag[];
}

const Specializations: React.FC<ISpecialization> = ({
    selected,
    handleChange,
    setTags,
    tags,
}) => {
    const dispatch = useDispatch();
  
    const defaultSelected: Tag = {
        createdAt: 0,
        updatedAt: 0,
        id: 0,
        type: 'specialization',
        description: "Doctor Specialiazation",
        name: "All",
        createdBy: 0
      }

    const {data, isFetching, isError } = useQuery('load-physicians-tags', async () => {
        const req: PagenatedRequest = {
            modelName: 'tag',
            returnType: 'list',
            crieteria: {
                type: "specialization",
            },
        
        }
    
        const ans = await api.getModelList<Tag>(req);
       
        return {specs: ans.data!.data.payload};
    
      });

      React.useEffect(() => {
        if(isError) { dispatch(putMessage({
              type: 'error',
              message: 'Failed to load specializations'
          }))}
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isError]);

    useEffect(() => {
        if(data && data.specs) {
            setTags([defaultSelected].concat(data.specs));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    if(isFetching) {
        return <CircularProgress />
    }

    return (
        <Box sx={{ minWidth: 200 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Specialization</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selected.id.toString()}
            label="Specialization"
            onChange={handleChange}
          >
            {tags.map((tag, index) => (
              <MenuItem key={'specialization-' + index} value={tag.id}>{tag.name}</MenuItem>
            ))}


          </Select>
          <FormHelperText>
            Currently viewing {selected.name === "All" ? "All" : pluralize(selected.name)}
          </FormHelperText>
        </FormControl>
      </Box>
    )
}

export default Specializations;
